import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { LoginService } from './login.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormValidator } from '../form.validator';
import { BrandService } from '../brand/brand.service';

declare var $: any;
declare var jquery: any;
declare var d3: any;
declare let customToastr: any;

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    providers: [LoginService, FormValidator]
})
export class LoginComponent implements OnInit {

    brand = this.brandService.brand;

    constructor(
        private loginservice: LoginService, private router: Router,
        private formValidator: FormValidator, private route: ActivatedRoute,
        private brandService: BrandService
    ) {


        // get subdomain name
        const full = window.location.host;
        // window.location.host is subdomain.domain.com
        const parts = full.split('.');
        const sub = parts[0];
        const domain = parts[1];
        const type = parts[2];

        console.log('Window location host: 222', full);
        console.log('Parts: ', parts);
        console.log('Sub: ', sub);
        console.log('Domain: ', domain);
        console.log('type: ', type);

        if (domain !== undefined) {
            this.getSchoolDomainName = sub;
            if (sub === 'registration' || sub === 'register') {
                // this.routingEnable = false;
                // this.registrationEnable = true;
            } else {
                const domainSuffix = this.brandService.brand.domainSuffix || window.location.hostname.split('.').slice(1).join('.');
                this.loginservice.validateDomain(sub, domainSuffix)
                    .subscribe(
                        (data: any) => {
                            if (data.errorcode === 10010 || data.errorcode === 10036) {
                                this.router.navigate(['/suspended']);
                            } else if (data.errorcode !== undefined) {
                                // for testing server
                                const domainSuffix = this.brandService.brand.domainSuffix || window.location.hostname.split('.').slice(1).join('.');
                                location.href = `https://registration.${domainSuffix}`;


                            } else {

                            }
                            const schoolName = data.schoolName;
                            const schoolState = data.state;
                            const schoolLogo = data.schoolImage;
                            const currencyType = data.currencyType;
                            this.isFranchise = parseInt(data.isFranchise);
                            this.fkFranchiseId = data.fkfranchiseId;
                            this.loginSchoolName = schoolName;
                            this.loginSchoolState = schoolState;
                            this.loginSchoolLogo = schoolLogo;
                            this.schoolCurrency = currencyType;
                            localStorage.setItem('currency', this.schoolCurrency);
                        },
                        error => {
                            console.error(error)
                        }
                    );
            }
        }


    }

    public static LOGIN_TOKEN;
    public static SCHOOL_DATA;

    preLoader = false;

    getAuthToken = localStorage.getItem('usertoken');
    getSchoolId = localStorage.getItem('schoolinfo');
    schoolCurrency = localStorage.getItem('currency');

    username: string;
    password: string;

    loginSchoolName;
    loginSchoolState;
    loginSchoolLogo;
    isFranchise;
    fkFranchiseId;

    getSchoolDomainName;

    loaderLogin = false;
    loginMode = 'WEB_ADMIN';
    loginError = false;
    errorMessage = {
        username: "",
        password: ""
    }

    currentYear;

    //for school admin
    loginAuth() {

        LoginComponent.LOGIN_TOKEN = null;
        LoginComponent.SCHOOL_DATA = [];
        if (this.formValidator.validateIsData(this.username) && this.formValidator.validateIsData(this.password)) {
            this.loaderLogin = true;
            const domainName = this.getSchoolDomainName;
            if (this.loginMode === 'WEB_ADMIN') {
                // call get class service with cat id
                this.loginservice.loginValidate(this.username, this.password, domainName)
                    .subscribe(
                        (data: any) => {
                            if (data.token !== undefined) {

                                this.loaderLogin = false;

                                LoginComponent.LOGIN_TOKEN = data.token;
                                LoginComponent.SCHOOL_DATA.push(data.schoolInfo);
                                localStorage.setItem('loginMode', this.loginMode);
                                localStorage.setItem('usertoken', LoginComponent.LOGIN_TOKEN);
                                localStorage.setItem('schoolinfo', data.schoolInfo.schoolId);
                                localStorage.setItem('adminType', data.schoolInfo.adminType);
                                localStorage.setItem('feesModuleSettings', JSON.stringify(data.schoolInfo.feesModuleSettings));
                                localStorage.setItem('currency', data.schoolInfo.currencyType);
                                localStorage.setItem('isFranchise', data.schoolInfo.isFranchise);
                                localStorage.setItem('fkFranchiseId', data.schoolInfo.fkFranchiseId);
                                data.schoolInfo.countryCode = data.schoolInfo.countryCode.startsWith('+') ? data.schoolInfo.countryCode.slice(1) : data.schoolInfo.countryCode;
                                localStorage.setItem('countryCode', data.schoolInfo.countryCode);
                                const d = {};
                                const arr = data.schoolInfo.adminPermissions;
                                arr.forEach(item => {
                                    d[item.BluewingsFeatureName] = item.ActiveStatus || item.AdminAccessStatus;
                                });
                                localStorage.setItem('adminPermissionlist', JSON.stringify(d));
                                if (data.schoolInfo.isFranchise == 1) {
                                    this.router.navigate(['/franchise/dashboard']);
                                }
                                else {
                                    this.router.navigate(['/dashboard']);
                                }
                            } else {
                                this.triggerLoginError();
                                this.loaderLogin = false;
                            }
                        },
                        error => {

                        }
                    );
            } else if (this.loginMode === 'STAFF') {
            
                
                this.loginservice.staffLogin(this.username, this.password, domainName)
                    .subscribe(
                        (data: any) => {
                            if (data.token) {
                                this.loaderLogin = false;
                                LoginComponent.LOGIN_TOKEN = data.token;
                                LoginComponent.SCHOOL_DATA.push(data.schoolInfo);
                                localStorage.setItem('loginMode', this.loginMode);
                                localStorage.setItem('usertoken', LoginComponent.LOGIN_TOKEN);
                                localStorage.setItem('schoolinfo', data.schoolInfo.schoolId);
                                localStorage.setItem('adminType', data.schoolInfo.adminType);
                                localStorage.setItem('feesModuleSettings', JSON.stringify([]));
                                localStorage.setItem('adminPermissionlist', JSON.stringify({ EXAM_MANAGEMENT: 'ENABLED' }));
                                this.router.navigate(['/exams']);
                            } else {
                                this.triggerLoginError();
                                this.loaderLogin = false;
                            }
                        },
                        error => {

                        }
                    );
            }
        } else {
            this.triggerLoginError();
        }
    }

    //for franchise admin
    loginAuth2(sclId, token) {

        LoginComponent.LOGIN_TOKEN = null;
        LoginComponent.SCHOOL_DATA = [];

        this.loginservice.schoolFranchiseLogin(sclId, token)
            .subscribe(
                (data: any) => {
                    if (data.token !== undefined) {

                        //this.loaderLogin = false;
                        LoginComponent.LOGIN_TOKEN = data.token;
                        LoginComponent.SCHOOL_DATA.push(data.schoolInfo);
                        localStorage.setItem('loginMode', this.loginMode);
                        localStorage.setItem('usertoken', LoginComponent.LOGIN_TOKEN);
                        localStorage.setItem('schoolinfo', data.schoolInfo.schoolId);
                        localStorage.setItem('adminType', data.schoolInfo.adminType);
                        localStorage.setItem('feesModuleSettings', JSON.stringify(data.schoolInfo.feesModuleSettings));

                        localStorage.setItem('currency', data.schoolInfo.currencyType);
                        localStorage.setItem('isFranchise', data.schoolInfo.isFranchise);
                        localStorage.setItem('fkFranchiseId', data.schoolInfo.fkFranchiseId);
                        data.schoolInfo.countryCode = data.schoolInfo.countryCode.startsWith('+') ? data.schoolInfo.countryCode.slice(1) : data.schoolInfo.countryCode;
                        localStorage.setItem('countryCode', data.schoolInfo.countryCode);
                        const d = {};
                        const arr = data.schoolInfo.adminPermissions;
                        arr.forEach(item => {
                            d[item.BluewingsFeatureName] = item.ActiveStatus || item.AdminAccessStatus;
                        });
                        localStorage.setItem('adminPermissionlist', JSON.stringify(d));

                        this.router.navigate(['/dashboard']);
                    }
                    else {
                        this.triggerLoginError();
                        //this.loaderLogin = false;
                    }
                },
                error => {

                }
            );

    }

    triggerLoginError() {

        if (!this.username) {
            this.errorMessage.username = "Please enter username"

        } else if (!this.password) {
            this.errorMessage.password = "Please enter password"
        } else {
            this.loginError = true;
            this.errorMessage.username = ""
            this.errorMessage.password = ""
            setTimeout(() => {
                this.loginError = false;
            }, 3000)
        }
    }

    // token auth
    isValidToken() {
        let isValidToken = false;
        let isValidSchool = 0;
        this.loginservice.isValidToken(this.getAuthToken)
            .subscribe(
                (data: any) => {
                    isValidToken = data.isValid;
                    if (data.errorcode === 10010) {
                        this.router.navigate(['/suspended']);
                    } else if (isValidToken === true) {
                        // this.router.navigate(['/dashboard']);
                        // school id validation///////////////////////////////////////////////
                        this.loginservice.isValidSchoolId(this.getSchoolId)
                            .subscribe((isValid: any) => {
                                isValidSchool = isValid.schoolExist;
                                if (isValidSchool === 1) {
                                    if (this.loginMode === 'STAFF') {
                                        this.router.navigate(['/exams']);
                                    } else {
                                        this.router.navigate(['/dashboard']);
                                    }
                                    this.preLoader = true;
                                } else {
                                    // this.router.navigate(['/login']);
                                    // this.preLoader = true;
                                }
                            },
                                error => {
                                }
                            );
                    } else {
                        // this.router.navigate(['/login']);
                        this.preLoader = true;
                    }
                },
                error => {

                }
            );
    }

    ngOnInit() {

        let url = window.location.href;
        let sclId = url.split("/")[5];
        let token = url.split("/")[6];

        if (sclId != undefined && token != undefined) {
            console.log("if part")
            this.loginAuth2(sclId, token);
        }
        else {
            console.log("else part")
            this.isValidToken();
        }

        //this.isValidToken();
        $('.after').append('<script type=\'text/javascript\' src=\'../../app/login/jquery-2.1.1.min.js\'>' +
            '</' + 'script><script src=\'app/login/materialize.min.js\'>' +
            '</' + 'script>');
        const currentTime = new Date();
        this.currentYear = currentTime.getFullYear();
    }

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvents(event) {
        if (event.key === 'Enter' && (event.target.id === 'user_name' || event.target.id === 'user_password')) {
            this.loginAuth();
        }
    }

    switchToStaffLogin() {
        $('#user_name').animate({ right: '50px', opacity: 1 }, 500);
        // $("#user_name").animate({right: 50, opacity: 1}, 500);

        $('#user_name').attr('placeholder', 'Enter mobile number for staff login');
        this.loginMode = 'STAFF';
    }

    switchToAdminLogin() {
        $('#user_name').attr('placeholder', 'Enter user name for admin login');
        this.loginMode = 'WEB_ADMIN';
    }
}
